import * as React from 'react';
import { UserState } from 'app/reducers/state';
import moment from 'moment';
import { each, filter } from 'lodash';
import { Callout, Intent, Tabs, Tab, Button, H4, TextArea, Spinner, Tooltip, H3 } from '@blueprintjs/core';
import { executeQueryPostAuth } from 'app/utils/api';

const JOURNAL_BLOCK_STYLE = {
    width: '100%',
    minHeight: '100px',
    display: 'block',
    backgroundColor: 'white',
    border: '1px solid #d9d9d9',
    marginBottom: '5px',
    padding: '5px'
}


interface GameData {
    postFeedback: string;
    preFeedback: string;
    userID: string;
    objectives: GameDataObjective[];
    submitted: string;
    "game-id": string;
    scenario: string;
    results: string;
}

interface GameDataObjective {
    academicDescription: string;
    category: string;
    description: string;
    name: string;
    result: string;
    submitted: string;
}

interface Props {
    user: UserState;
    selectedGame: GameData;
    canEditJournal?: boolean;
    inSimulator?: boolean;
    updateJournalDataInline: (stage: string, payload: string, gameID: string) => void;
};

interface State {
    showPreAppend: boolean;
    showPostAppend: boolean;
    preAppendContent: string;
    postAppendContent: string;
    loadingAppendData: boolean;
}

export class PlayDetailsClassic extends React.Component<Props, State> {

    state: State = {
        showPostAppend: false,
        showPreAppend: false,
        loadingAppendData: false,
        preAppendContent: "",
        postAppendContent: ""
    }

    componentDidMount() {

    }

    getAllCategories = () => {
        const {
            selectedGame
        } = this.props;

        let uniqueCategoryNames: string[] = [];

        each(selectedGame.objectives, objective => {
            if (!uniqueCategoryNames.includes(objective.category)) {
                uniqueCategoryNames.push(objective.category)
            }
        });

        return uniqueCategoryNames.sort();
    }

    getAllEntriesForACategory = (category: string) => {
        const {
            selectedGame
        } = this.props;

        return filter(selectedGame.objectives, objective => {
            return objective.category === category;
        });
    }

    getPreFeedback = () => {
        const {
            selectedGame
        } = this.props;

        if (selectedGame.preFeedback === "" || selectedGame.preFeedback === "None" || selectedGame.preFeedback === undefined) {
            return "Not Entered";
        }

        return selectedGame.preFeedback;
    }

    getPostFeedback = () => {
        const {
            selectedGame
        } = this.props;

        if (selectedGame.postFeedback === "" || selectedGame.postFeedback === "None" || selectedGame.postFeedback === undefined) {
            return "Not Entered";
        }

        return selectedGame.postFeedback;
    }

    getCanEditJouranl = () => {
        const {
            canEditJournal,
        } = this.props;

        const {
            showPostAppend,
            showPreAppend
        } = this.state;

        if (showPreAppend) {
            return false;
        }

        if (showPostAppend) {
            return false;
        }

        if (canEditJournal === true) {
            return true;
        }

        return false;
    }

    convertScenarioToFullName = (scenario: string) => {
        if (scenario === 'scenario_1') {
            return "Module 2 Explore";
        }

        if (scenario === 'scenario_1_assess') {
            return "Module 2 Assess";
        }

        if (scenario === 'scenario_1_a1') {
            return "Lesson 1";
        }

        if (scenario === 'scenario_1_a2') {
            return "Lesson 2";
        }

        if (scenario === 'scenario_1_a3') {
            return "Lesson 3";
        }
    }

    getPanelTitle = (): any => {
        const {
            selectedGame
        } = this.props;

        const scoreResults = Math.round((parseFloat(selectedGame.results))) + "%";

        return <span>
            <span>
                {this.convertScenarioToFullName(selectedGame!.scenario)}
            </span>
            <span style={{marginLeft: '20px'}}>
                Score: <span className="score-circle">{scoreResults}</span>
            </span>
            <span style={{float: 'right', fontSize: '15px'}}>
                {moment(selectedGame!.submitted).format("LLLL")}
            </span>
        </span>
    }

    renderScoreDisplay = () => {
        const {
            selectedGame
        } = this.props;

        //@ts-ignore
        const commitmentScore = parseFloat(selectedGame.base.commitmentScore);
        //@ts-ignore
        const sub1Score = parseFloat(selectedGame.base.fi);
        //@ts-ignore
        const sub2Score = parseFloat(selectedGame.base.ci);
        //@ts-ignore
        const sub3Score = parseFloat(selectedGame.base.er);

        const businessScore = Math.round((sub1Score + sub2Score + sub3Score) / 3.0);

        const finalScore = (commitmentScore + businessScore) / 2.0;

        const scoreLabelStyle = {fontSize: '40px'}

        const finalScoreTooltipContent =      `( ${Math.round(businessScore)} + ${Math.round(commitmentScore)} ) A combination of your Business Score and Commitment Score gives you your final score`;
        const businessScoreTooltipContent =   `( ${Math.round(sub1Score)} + ${Math.round(sub2Score)} + ${Math.round(sub3Score)} ) A combination all the impact factors gives you your Business Score`;
        const fiScoreTooltipContent =         "The Financial Impact of your outcome";
        const ciScoreTooltipContent =         "The Customer Impact of your outcome";
        const erScoreTooltipContent =         "The Employee Retention Impact of your outcome";
        const commitmentScoreTooltipContent = "How commited was each member of the team.  Try getting the other members of the meeting to talk more.";

        const finalScoreContent =      <Tooltip content={finalScoreTooltipContent}>{Math.round(finalScore)}</Tooltip>
        const businessScoreContent =   <Tooltip content={businessScoreTooltipContent}>{Math.round(businessScore)}</Tooltip>
        const fiScoreContent =         <Tooltip content={fiScoreTooltipContent}>{Math.round(sub1Score)}</Tooltip>
        const ciScoreContent =         <Tooltip content={ciScoreTooltipContent}>{Math.round(sub2Score)}</Tooltip>
        const erScoreContent =         <Tooltip content={erScoreTooltipContent}>{Math.round(sub3Score)}</Tooltip>
        const commitmentScoreContent = <Tooltip content={commitmentScoreTooltipContent}>{Math.round(commitmentScore)}</Tooltip>

        return <span style={{flexGrow: 1, flexBasis: 0}}>
            <span style={{flexShrink: 1, transition: 'all 2s'}}>
                <span style={{position: 'relative'}}>
                    <table className="classicScoreTable">
                        <tr><td><H3 style={{fontSize: '45px'}}>Your Score </H3> </td><td style={scoreLabelStyle}>{finalScoreContent}</td></tr>
                        <tr><td><H3>Business Score </H3> </td><td style={scoreLabelStyle}>{businessScoreContent}</td></tr>
                        <tr><td><H4>Financial Impact </H4> </td><td style={scoreLabelStyle}>{fiScoreContent}</td></tr>
                        <tr><td><H4>Customer Impact </H4> </td><td style={scoreLabelStyle}>{ciScoreContent}</td></tr>
                        <tr><td><H4>Employee Retention </H4> </td><td style={scoreLabelStyle}>{erScoreContent}</td></tr>
                        <tr><td><H3>Commitment Score </H3> </td><td style={scoreLabelStyle}>{commitmentScoreContent}</td></tr>
                    </table>
                    </span>
            </span>
        </span>
    }

    renderCategoryPanel = (category: any) => {
        const categoryEntries = this.getAllEntriesForACategory(category);

        let entries: JSX.Element[] = [];

        each(categoryEntries, (entry) => {
            const isSuccessfull = entry.result === "True" || entry.result === "true";

            entries.push(
                <Tooltip content={entry.academicDescription}>
                    <Callout className={"single-view-callout " + (isSuccessfull ? "callout-green-icon" : "callout-red-icon")} icon={isSuccessfull ? "tick" : "minus"} title={entry.name}>
                        {entry.description}
                    </Callout>
                </Tooltip>
            )
        });

        return <span style={{width: '100%'}}>
            {entries}
        </span>
    }

    renderClassicScoreOverview = () => {

    }

    renderCategorySelection = () => {
        const categories = this.getAllCategories();

        let categoryMenu: JSX.Element[] = [];

        each(categories, category => {
            const categoryEntries = this.getAllEntriesForACategory(category);
            const categoryTotal = categoryEntries.length;
            const categorySuccess = filter(categoryEntries, (entry:GameDataObjective) => { return entry.result === "True"}).length;

            const menuLabel = "(" + categorySuccess.toString() + "/" + categoryTotal.toString() + ") " + category;

            categoryMenu.push(
                <Tab id={"tb_single_" + category} title={menuLabel} panel={this.renderCategoryPanel(category)} />
            );
        });

        return <span className="bold-tab-menu">
            <Tabs
                animate={true}
                id="single_score_objective_view"
                key={"horizontal"}
                renderActiveTabPanelOnly={false}
                vertical={true}
            >
                {categoryMenu}
            </Tabs>
        </span>
    }

    updateFeedbackContent = (stage: string, feedback: string) => {
        this.setState({
            showPostAppend: false,
            showPreAppend: false,
            loadingAppendData: true,
            preAppendContent: "",
            postAppendContent: ""
        });

        const queryBase = "data/feedback/" + stage + "/" + this.props.selectedGame["game-id"];

        const existingContent = (stage === "pre") ? this.getPreFeedback() : this.getPostFeedback();

        const newPayload = existingContent + "\r\n" + moment().format("LLLL") + "\r\n" + feedback;

        executeQueryPostAuth(queryBase, {
            feedback: newPayload
        }, this.props.user, () => {
            // Refresh the page now

            this.props.updateJournalDataInline(stage, newPayload, this.props.selectedGame["game-id"]);

            this.setState({
                loadingAppendData: false
            });
        });
    }

    renderPreAppend = () => {
        const {
            showPreAppend,
            preAppendContent
        } = this.state;

        if (!showPreAppend) return undefined;

        return <span>
            <TextArea
                growVertically={true}
                large={true}
                intent={Intent.PRIMARY}
                style={{width: '100%', marginBottom: '5px'}}
                onChange={(event) => {
                    this.setState({
                        preAppendContent: event.target.value
                    });
                }}
                value={preAppendContent}
            />
            {this.renderNormalButton("", () => {
                this.updateFeedbackContent("pre", preAppendContent);
            }, Intent.SUCCESS, "Save")}
        </span>
    }
    
    renderPostAppend = () => {
        const {
            showPostAppend,
            postAppendContent
        } = this.state;

        if (!showPostAppend) return undefined;

        return <span>
            <TextArea
                growVertically={true}
                large={true}
                intent={Intent.PRIMARY}
                style={{width: '100%', marginBottom: '5px'}}
                onChange={(event) => {
                    this.setState({
                        postAppendContent: event.target.value
                    });
                }}
                value={postAppendContent}
            />
            {this.renderNormalButton("", () => {
                this.updateFeedbackContent("post", postAppendContent);
            }, Intent.SUCCESS, "Save")}
        </span>
    }

    renderSimulatorJournal = () => {
        const {
            inSimulator
        } = this.props;

        if (inSimulator !== true) {
            return <span></span>
        }

        return <span style={{display: 'block', width: '100%', height: '150px', marginTop: '0px'}}>
            <span style={JOURNAL_BLOCK_STYLE}>{this.getPreFeedback()}</span>
        </span>
    }

    renderJournal = () => {
        const {
            inSimulator
        } = this.props;

        if (inSimulator === true) {
            return <span></span>
        }

        const canEditJournal = this.getCanEditJouranl();

        return <span style={{display: 'block', marginTop: '20px'}}>
            <span style={{display: 'inline-block', width: '50%', paddingRight: '5px'}}>
                <H4>Pre</H4>
                <span style={JOURNAL_BLOCK_STYLE}>{this.getPreFeedback()}</span>
                <span>
                    {this.renderPreAppend()}
                    {canEditJournal ? this.renderNormalButton("edit", () => { this.setState({preAppendContent: "", showPreAppend: true}); }, Intent.NONE, "Append Your Journal Entry") : undefined}
                </span>
            </span>
            <span style={{display: 'inline-block', width: '50%', paddingLeft: '5px', float: 'right'}}>
                <H4>Post</H4>
                <span style={JOURNAL_BLOCK_STYLE}>{this.getPostFeedback()}</span>
                <span>
                    {this.renderPostAppend()}
                    {canEditJournal ? this.renderNormalButton("edit", () => { this.setState({postAppendContent: "", showPostAppend: true}); }, Intent.NONE, "Append Your Journal Entry") : undefined}
                </span>
            </span>
            <div className="clearfix" />
        </span>
    }

    renderNormalButton = (rightIcon: any, onClick: any, intent: any, text: string) => {
		return <Button style={{margin: '0px', width: '100%'}} rightIcon={rightIcon} onClick={() => { onClick(); }} intent={intent} text={text} />
	}

	render() {
        const {
            loadingAppendData
        } = this.state;

        return <span>
            <Callout className="playDetails" style={{marginBottom: '10px'}} intent={Intent.NONE} icon={"play"} title={this.getPanelTitle()}>
                {/* {this.renderCategorySelection()} */}
                {this.renderScoreDisplay()}
                {loadingAppendData ? <Spinner /> : this.renderJournal()}
                {this.renderSimulatorJournal()}
            </Callout>
        </span>
	}
}
